module.exports = __webpack_public_path__ + "static/media/plus-symbolc3104b91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/plus-symbol.svg
// module id = 1523
// module chunks = 0